// DO NOT CHANGE -- THIS FILE IS GENERATED

const theme = {
  primary: '#00A59A',
  secondary: '#12243E',
  third: '#4B1D3F',
};

export default theme;
